module.exports = __webpack_public_path__ + "static/media/5-iveco-mercedes.29b1f6b5.jpg";